import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

export type EmptyStateProps = {
  title: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  /** Tek bir cikis yolu — "Filtreleri temizle", "Hesap ekle" gibi. */
  action?: ReactNode;
  tone?: 'neutral' | 'error';
  className?: string;
};

export function EmptyState({
  title,
  description,
  icon,
  action,
  tone = 'neutral',
  className,
}: EmptyStateProps) {
  return (
    <div
      className={[styles.empty, styles[tone], className].filter(Boolean).join(' ')}
      role={tone === 'error' ? 'alert' : undefined}
    >
      {icon ? <div className={styles.icon}>{icon}</div> : null}
      <p className={styles.title}>{title}</p>
      {description ? <p className={styles.description}>{description}</p> : null}
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
}
